import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static values = {
        theme: { type: String, default: 'bg-info' },
        header: { type: String, default: '!' },
        message: { type: String, default: '' },
        life: { type: Number, default: 3000 }
    }

    connect() {
        toast(
            this.messageValue, {
                theme: this.themeValue,
                header: this.headerValue,
                life: this.lifeValue
            }
        );
    }
}
